import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CrmApiService } from '@shared/core/services/crm-api.service';
import { BackendApiResponse, ProductConfiguration } from '@shared/core/types';
import { convertApiItemResponseToItem } from '@shared/core/utils';

@Injectable({
  providedIn: 'root',
})
export class ProductConfigApiService extends CrmApiService {
  getProductConfigList(): Observable<ProductConfiguration[]> {
    return this.api
      .get<BackendApiResponse<ProductConfiguration[]>>(`${this.baseEndpoint}products/configurations/`)
      .pipe(
        convertApiItemResponseToItem,
        catchError(() => of([])),
      );
  }
}
